import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';
import { getClaim } from '../../../../../claim';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    updateFormDetails?: UpdateFormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const medicalAidDetailsView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    claimType,
}: Props) => {
    const medicalAidDetails = formDetails?.lifeAssured?.medicalAidDetails;

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Medical Aid details
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                {claimType !== ClaimType.Disability && (
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            <Grid item xs={4} lg={12}>
                                <LabeledValue
                                    label="Life Assured has medical aid?"
                                    value={medicalAidDetails?.hasMedicalAid}
                                />
                            </Grid>
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid number"
                                        value={medicalAidDetails?.lifeAssuredMedicalAidNumber}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid name"
                                        value={medicalAidDetails?.lifeAssuredMedicalAidName}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Date Joined"
                                        value={getDisplayDate(
                                            medicalAidDetails?.lifeAssuredMedicalDateJoined
                                        )}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Is the life assured a main member"
                                        value={medicalAidDetails?.isLifeAssuredMainMember}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member Title"
                                    value={medicalAidDetails?.lifeAssuredTitle}
                                />
                            </Grid>
                        )}
                        {medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member full name"
                                    value={medicalAidDetails?.lifeAssuredName}
                                />
                            </Grid>
                        )}
                        {medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member surname"
                                    value={medicalAidDetails?.lifeAssuredSurname}
                                />
                            </Grid>
                        )}
                        {medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member ID"
                                    value={medicalAidDetails?.lifeAssuredIdNumber}
                                />
                            </Grid>
                        )}
                    </Grid>
                )}
                {claimType === ClaimType.Disability && (
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            <Grid item xs={4} lg={12}>
                                <LabeledValue
                                    label="Does the life assured have a medical aid?"
                                    value={medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid}
                                />
                            </Grid>
                            {medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid name"
                                        value={medicalAidDetails?.medicalAidName}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid name (Other)"
                                        value={medicalAidDetails?.otherMedicalAidName}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid number"
                                        value={medicalAidDetails?.medicalAidNumber}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Date Joined"
                                        value={getDisplayDate(medicalAidDetails?.dateJoined)}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Is the life assured the main member on the medical aid?"
                                        value={
                                            medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid
                                        }
                                    />
                                </Grid>
                            )}
                        </Grid>

                        {medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member's first name"
                                    value={medicalAidDetails?.mainMembersFirstName}
                                />
                            </Grid>
                        )}
                        {medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main member's surname"
                                    value={medicalAidDetails?.mainMembersSurname}
                                />
                            </Grid>
                        )}
                        {medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid === 'No' && (
                            <Grid item xs={4} lg={3}>
                                <LabeledValue
                                    label="Main members ID number or passport number"
                                    value={medicalAidDetails?.mainMembersIdNumberOrPassportNumber}
                                />
                            </Grid>
                        )}
                    </Grid>
                )}
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const MedicalAidDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(medicalAidDetailsView));
